<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { userLogin, getBooks } from "./api";
import { setToken, getToken } from "./utils/auth";
export default {
  created() {
    userLogin("search_api@hep.com.cn", "hep888").then((response) => {
      setToken(response.data.token);
    });
  },
};
</script>
<style scoped>
body {
  margin: 0px;
  padding: 0px;
}
</style>
